// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_Xpfu3{flex:1 1 auto;width:100%;font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.tabsBar_QOhqy{position:relative;display:flex;flex:0 1 auto;border-radius:inherit;height:48px;max-width:100%;color:#272525}.sliderWrapper_fn8d9,.tabsBar_QOhqy{transition:.3s cubic-bezier(.25,.8,.5,1)}.sliderWrapper_fn8d9{position:absolute;bottom:0;margin:0!important;z-index:1}.slider_JaRi0{height:100%;width:100%;background-color:currentColor}", ""]);
// Exports
exports.locals = {
	"container": "container_Xpfu3",
	"tabsBar": "tabsBar_QOhqy",
	"sliderWrapper": "sliderWrapper_fn8d9",
	"slider": "slider_JaRi0"
};
module.exports = exports;
